"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({ value: zod_1.z.string().optional() });
const dataSchema = zod_1.z.object({
    value: zod_1.z
        .string((0, validation_1.labelZodErrors)("Email"))
        .email("Must be a valid email.")
        .min(5, "Must be a valid email."),
});
exports.default = new ItemDefinition_1.ItemDefinition("Email", configSchema, dataSchema, new validation_1.ValidatorPipeline("Email Config Validator", []), new validation_1.ValidatorPipeline("Email Data Validator", []));
//# sourceMappingURL=Email.js.map